import React from 'react';
import { useIntl } from 'react-intl';
import { PropTypes } from 'prop-types';

import SocialIcon from './SocialIcon';

import { logos } from './logos';

import { DynamicContainer } from '../Layout/DynamicContainer';

import { ContainerType } from '../Layout/constants';

const SocialNetworks = ({ rules, inNavigation, inContact }) => {
    const { formatMessage } = useIntl();

    if (inNavigation) {
        return (
            <DynamicContainer inNavigation={inNavigation} type={ContainerType.FLEX} extend={rules.extendContainer}>
                {logos.map(({ alt, link, src }, index) => (
                    <React.Fragment key={index}>
                        {alt && link && src ? (
                            <SocialIcon link={formatMessage({ id: link })} src={src} inNavigation={inNavigation} />
                        ) : null}
                    </React.Fragment>
                ))}
            </DynamicContainer>
        );
    }

    if (inContact) {
        return (
            <DynamicContainer extend={{ container: rules.contactContainer }} type={ContainerType.FLEX}>
                {logos.map(({ alt, link, src }, index) => (
                    <React.Fragment key={index}>
                        {alt && link && src ? (
                            <SocialIcon
                                key={formatMessage({ id: alt })}
                                link={formatMessage({ id: link })}
                                src={src}
                                extend={{ container: rules.contactIconContainer, icon: rules.contactIcon }}
                            />
                        ) : null}
                    </React.Fragment>
                ))}
            </DynamicContainer>
        );
    }

    return (
        <>
            <DynamicContainer eventId="footer-social" extend={rules.extendContainer} columns={7}>
                {logos.map(({ alt, link, src }, index) => (
                    <React.Fragment key={index}>
                        {alt && link && src ? (
                            <SocialIcon key={formatMessage({ id: alt })} link={formatMessage({ id: link })} src={src} />
                        ) : null}
                    </React.Fragment>
                ))}
            </DynamicContainer>
        </>
    );
};

SocialNetworks.propTypes = {
    rules: PropTypes.shape().isRequired,
    inNavigation: PropTypes.bool,
    inContact: PropTypes.bool,
};

SocialNetworks.defaultProps = {
    inNavigation: false,
    inContact: false,
};

export default SocialNetworks;
